define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ERROR_EVENT = exports.SERVICE_REQUEST_ERROR = exports.SERVICE_REQUEST_SUCCESS = exports.SERVICE_REQUEST_INIT = exports.ENTITY_DRAW_EVENT = exports.ENTITY_CREATE_ERROR_EVENT = exports.ENTITY_CREATED_EVENT = exports.ENTITY_CREATE_EVENT = exports.ENTITY_CLOSE_ERROR_EVENT = exports.ENTITY_CLOSED_EVENT = exports.ENTITY_CLOSE_EVENT = exports.ENTITY_OPEN_ERROR_EVENT = exports.ENTITY_OPENED_EVENT = exports.ENTITY_OPEN_EVENT = exports.USER_LOGGED_OUT_EVENT = exports.USER_LOGGING_OUT_EVENT = exports.USER_LOGGED_IN_EVENT = exports.USER_LOGGING_IN_EVENT = exports.VALIDATION_CLEAR_EVENT = exports.VALIDATION_UPDATE_EVENT = exports.REDLINES_CHANGE_EVENT = exports.MAP_REFRESH_EVENT = exports.MAP_CLICK_EVENT = exports.MAP_READY_EVENT = exports.CONFIG_READY_EVENT = exports.ROUTE_ENTER_EVENT = exports.ROUTE_PUSH_EVENT = void 0;
    exports.ROUTE_PUSH_EVENT = "route.request";
    exports.ROUTE_ENTER_EVENT = "route.enter";
    exports.CONFIG_READY_EVENT = "config.ready";
    exports.MAP_READY_EVENT = "map.ready";
    exports.MAP_CLICK_EVENT = "map.click";
    exports.MAP_REFRESH_EVENT = "map.refresh";
    exports.REDLINES_CHANGE_EVENT = "redlines.change";
    exports.VALIDATION_UPDATE_EVENT = "validation.update";
    exports.VALIDATION_CLEAR_EVENT = "validation.clear";
    exports.USER_LOGGING_IN_EVENT = "user.loggingIn";
    exports.USER_LOGGED_IN_EVENT = "user.loggedIn";
    exports.USER_LOGGING_OUT_EVENT = "user.loggingOut";
    exports.USER_LOGGED_OUT_EVENT = "user.loggedOut";
    exports.ENTITY_OPEN_EVENT = "entity.open.init";
    exports.ENTITY_OPENED_EVENT = "entity.open.success";
    exports.ENTITY_OPEN_ERROR_EVENT = "entity.open.error";
    exports.ENTITY_CLOSE_EVENT = "entity.close.init";
    exports.ENTITY_CLOSED_EVENT = "entity.close.success";
    exports.ENTITY_CLOSE_ERROR_EVENT = "entity.close.error";
    exports.ENTITY_CREATE_EVENT = "entity.create.init";
    exports.ENTITY_CREATED_EVENT = "entity.create.success";
    exports.ENTITY_CREATE_ERROR_EVENT = "entity.create.error";
    exports.ENTITY_DRAW_EVENT = "entity.draw";
    exports.SERVICE_REQUEST_INIT = "service.init";
    exports.SERVICE_REQUEST_SUCCESS = "service.success";
    exports.SERVICE_REQUEST_ERROR = "service.error";
    exports.ERROR_EVENT = "error";
});
